module.exports = __webpack_public_path__ + "img/katarina_events_17.b2df2671.jpg";